import React, { useState, useEffect } from "react";
import { AddFileDialog } from "../shared/addFileDialog";
import { consulationService } from '../../services/api/consultation.service';
import { alertService } from '../../services/helpers/alert.service';
import { filesService } from '../../services/api/files.service'; 
import { utils } from "../../services/helpers/utils";

export const ConsultationFiles = (props) => {

    const [fileList, setFileList] = useState([]);
    const [visibleFileDialog, setVisibleFileDialog] = React.useState(false);

    const toggleFileDialog = () => {
        setVisibleFileDialog(!visibleFileDialog);
    };

    const addFile = (file) => {
        var customFile = {
            descriere: file.descriere,
            nume: file.numeFisier,
            fisier: file.rawFile,
            dimensiune: file.rawFile.size
        }
        var newFile = [...fileList, customFile]
        setFileList(newFile);
        props.setFisiere(newFile);
        props.setIsModified(true);
    }

    const handleView = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.getFile({ queryString: item.downloadId, partener: props.partener })
                .then(response => {
                    if (response) {
                        utils.viewResponse(response, item.nume)
                    }
                })
                

        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }


    const handleDownload = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.downloadFile({ queryString: item.downloadId });
        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }

    
    useEffect(() => {

        if (props && props.consultatie) {
            consulationService.getFiles({ consultation: props.consultatie })
                .then(response => {
                    if (response) {
                        setFileList(response);
                        if (props.setFisiere) {
                            props.setFisiere(response)
                        }
                    }
                });
        }
    }, [props.render]);

    function handleDelete(index) {

        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi acest fisier?"
            , () => {
                var list = [...fileList];
                list.splice(index, 1);
                setFileList(list);
                props.setFisiere(list);
                props.setIsModified(true);
            }
            , () => { return; }
        );
        
    }

    return (

        <div className="pt20">
        <fieldset>
            <legend className="pb5">Fisiere</legend>
            <table className="tbl tbladd mt5" name="lista_fisiere" width="100%">
                <thead>
                    <tr>
                        <th>Nume fisier</th>
                        <th>Descriere</th>
                        <th>Dimensiune</th>
                        { props.statusFinalizare !== 1 && <th width="50">Sterge</th> }
                        <th width="50">Vizualizeaza</th>
                        <th width="50">Download</th>
                    </tr>
                </thead>
                <tbody>
                    {fileList.map((file, index) => (
                        <tr key={index}>
                            <td name="nume_fisier"> {file.nume} </td>
                            <td name="descriere">{file.descriere}</td>
                            <td name="dimensiune"> {file.dimensiune}</td>
                            {
                                props.statusFinalizare !== 1 &&
                                <td>
                                    <span className="icon sterge center" name="fisier_del" onClick={() => handleDelete(index)}></span>
                                </td>
                            }
                            <td>
                                <span className="icon deschide center" name="fisier_view" onClick={() => handleView(file)}></span>
                            </td>
                            <td>
                                <span className="icon download center" name="fisier_down" onClick={() => handleDownload(file)} ></span>
                            </td>
                        </tr>
                    ))}
                </tbody>
                </table>
                {
                    props.statusFinalizare !== 1 &&
                    <button name="adauga_fisier"
                        className="btn mt10"
                        onClick={toggleFileDialog}
                    >Adauga fisier

                    </button>
                }
            </fieldset>

            {visibleFileDialog && <AddFileDialog toggleDialog={toggleFileDialog} addFile={addFile} />}
        </div>
    );
}